import { render, staticRenderFns } from "./DialogProductThankYou.vue?vue&type=template&id=2771a4c4&scoped=true"
import script from "./DialogProductThankYou.vue?vue&type=script&lang=js"
export * from "./DialogProductThankYou.vue?vue&type=script&lang=js"
import style0 from "./DialogProductThankYou.vue?vue&type=style&index=0&id=2771a4c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771a4c4",
  null
  
)

export default component.exports